import {InsertDriveFileOutlined} from '@mui/icons-material';
import {GridColumns} from '@mui/x-data-grid';
import {PopoverTypography} from 'src/components/common/PopoverTypography';
import {DeleteFileFromLocationAction} from '../DeleteFileFromLocationAction';
import {DownloadFileFromLocationAction} from '../DownloadFileFromLocationAction';
import {FilesMenu} from './FilesMenu';
import {formatFileName} from '../../../utils/helper';

/**
 * Takes what the caller may see rather than what they are called. The role name it replaced
 * could not answer for a business-defined role, and the column would simply have stayed hidden.
 */
export const columnConfigLocationFiles = (isPlatformAdmin: boolean): GridColumns => [
    {
        field: 'id',
        flex: 1,
        cellClassName: 'ampTableCell',
        renderCell: () => <InsertDriveFileOutlined/>,
    },
    {
        field: 'name',
        flex: 6,
        cellClassName: 'ampTableCell',
        renderCell: (params) => {
            const formattedName = formatFileName(params.row.name);
            return (
                <PopoverTypography
                    text={decodeURI(formattedName)}
                    popoverText={decodeURI(formattedName)}
                />
            );
        },
    },
    {
        field: 'download',
        flex: 1,
        cellClassName: 'ampTableCell hoverableCell',
        renderCell: (params) => (
            <DownloadFileFromLocationAction
                row={params.row}
                name={params.row.name}
            />
        ),
    },
    {
        field: 'delete',
        flex: 1,
        cellClassName: 'ampTableCell hoverableCell',
        // No `hide` here. It hid the column from the platform administrator alone - the one account
        // that certainly holds locationFiles.delete - while the action inside gates itself on that
        // permission for everybody else. Two gates, and the wrong one was deciding.
        renderCell: (params) => <DeleteFileFromLocationAction row={params.row}/>,
    },
];

export const columnConfigLocationFilesSm = (isPlatformAdmin: boolean): GridColumns => [
    {
        field: 'id',
        flex: 1,
        cellClassName: 'ampTableCell',
        renderCell: () => <InsertDriveFileOutlined/>,
    },
    {
        field: 'name',
        flex: 6,
        cellClassName: 'ampTableCell',
        renderCell: (params) => (
            <PopoverTypography
                text={decodeURI(formatFileName(params.row.name))}
                popoverText={decodeURI(formatFileName(params.row.name))}
            />
        ),
    },
    {
        field: 'actions',
        flex: 1,
        cellClassName: 'ampTableCell hoverableCell',
        renderCell: (params) => (
            <FilesMenu
                row={params.row}
                name={params.row.name}
                isSuperAdmin={isPlatformAdmin}
            />
        ),
    },
];
